<template>
  <div class="title_div">
    <div class="title_h3">{{ forms.h1 }}</div>
    <div class="title_p">{{ forms.h2 }}</div>
  </div>
</template>

<script>

export default {
  props: ["forms"],
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.title_div {
  width: 100%;
  height: 200px;
  display: grid;
  　justify-items: center; // 主轴居中
  　　align-items: center; // 交叉轴居中

  .title_h3 {
    text-align: center;
    height: 100px;
    line-height: 100px;
  
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #252525;
  }
  .title_h3:after {
    position: absolute;
    content: "";
    width: 3%;
    height: 3px;
    background: #ff9c22;
    left: 48.5%;
    top: 100px;
  }
  .title_p {
    text-align: center;

    font-size: 38px;
    font-family: Arial;
    font-weight: bold;
    color: #0084ca;
    line-height: 52px;
  }
}
</style>
